import styled from 'styled-components';

export const GradientWrapper = styled.div`
  background: url('/home/background-gradient.svg') center center no-repeat;
  background-size: cover;
`;
